import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
 import { IpdRegistrationComponent } from './ipd-registration/ipd-registration.component';
 import { IpdDashboardComponent } from './ipd-dashboard/ipd-dashboard.component';
const routes: Routes = [
  
  {path:'',component:IpdDashboardComponent},
  {path:'ipd',component:IpdRegistrationComponent},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class IpdRoutingModule { }
